import httpRequest from 'httpRequest'
import {
    PrinterSlimContract,
    PrinterContract,
    PrinterConnectivityContract,
    CompletableContract,
} from 'models'

const PRINTER_PREFIX = '/location/printers'

const printerService = {
    getAllPrinter() {
        return httpRequest.get<PrinterSlimContract[]>(PRINTER_PREFIX)
    },
    getPrinter(printerId: string) {
        return httpRequest.get<PrinterContract>(
            `${PRINTER_PREFIX}/${printerId}`,
        )
    },
    createPrinter(printer: PrinterContract) {
        return httpRequest.post<string>(PRINTER_PREFIX, printer)
    },
    updatePrinter(printerId: string, printer: PrinterContract) {
        return httpRequest.put<PrinterContract>(
            `${PRINTER_PREFIX}/${printerId}`,
            printer,
        )
    },
    deletePrinter(printerIds: string[]) {
        return httpRequest.delete(PRINTER_PREFIX, { params: { printerIds } })
    },
    checkPrinterStatus: () =>
        httpRequest.get<boolean>(`${PRINTER_PREFIX}/can-print`),
    getPrinterConnectivity: () =>
        httpRequest.get<PrinterConnectivityContract[]>(
            `${PRINTER_PREFIX}/connectivity`,
        ),
    testKitchenPrinter: (testPrinterId: string, dedicatedClientId?: string) => {
        let params = ''
        if (dedicatedClientId) params = '?testClientId=' + dedicatedClientId

        return httpRequest.post<CompletableContract>(
            `${PRINTER_PREFIX}/test-kitchen-print/${testPrinterId}${params}`,
        )
    },
}

export default printerService
